import ReactGA from 'react-ga4';
import posthog from 'posthog-js';
import { trackEvent as trackPostHogEvent, identifyUser as identifyPostHogUser, resetUser as resetPostHogUser, setUserProperties as setPostHogUserProperties } from '../utils/posthogUtils';
import { environment } from '../environment/environment';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initializePostHog = () => {
  try {
    const { posthogKey, posthogHost, posthogEnabled } = environment;
    if (!posthogEnabled) {
      console.log('PostHog disabled for this environment');
      return;
    }
    if (!posthogKey || !posthogHost) {
      console.warn('PostHog credentials not found in environment config');
      return;
    }
    posthog.init(posthogKey, {
      api_host: posthogHost,
    });
    console.log('PostHog initialized');
  } catch (error) {
    console.error('Error initializing PostHog:', error);
  }
};


export const initializeGA4 = () => {
  try {
    if (!GA_MEASUREMENT_ID) {
      console.warn('GA4 Measurement ID not found in environment variables');
      return;
    }
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('Google Analytics 4 initialized with ID:', GA_MEASUREMENT_ID);
  } catch (error) {
    console.error('Error initializing GA4:', error);
  }
};

export const setUserID = (userId: string, userProperties?: Record<string, any>) => {
  try {
    if (!userId) {
      console.warn('User ID is empty');
      return;
    }
    ReactGA.set({ 'user_id': userId });
    identifyPostHogUser(userId, userProperties);
    console.log('User ID set in GA4:', userId);
  } catch (error) {
    console.error('Error setting user ID in GA4:', error);
  }
};

export const trackPageView = (pageName: string) => {
  try {
    ReactGA.event('page_view', {
      'page_path': pageName,
      'page_title': pageName
    });
  } catch (error) {
    console.error('Error tracking page view in GA4:', error);
  }
};

export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  try {
    ReactGA.event(eventName, eventParams);
    trackPostHogEvent(eventName, eventParams);
    console.log('Event tracked in GA4:', eventName, eventParams);
  } catch (error) {
    console.error('Error tracking event in GA4:', error);
  }
};

export const setUserProperties = (properties: Record<string, any>) => {
  try {
    ReactGA.set(properties);
    setPostHogUserProperties(properties);
    console.log('User properties set in GA4:', properties);
  } catch (error) {
    console.error('Error setting user properties in GA4:', error);
  }
};

export const clearUserID = () => {
  try {
    ReactGA.set({ 'user_id': undefined });
    resetPostHogUser();
    console.log('User ID cleared in GA4');
  } catch (error) {
    console.error('Error clearing user ID in GA4:', error);
  }
};
